import * as React from "react";
import { useMemo } from "react";
import { useFormikContext } from "formik";
import usePluginEntities from "hooks/usePluginEntities";
const validationMessageRenderer = (validationErrors) => (fieldName, defaultText) => validationErrors[fieldName] ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, defaultText), "\xA0", /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, validationErrors[fieldName]))) : /* @__PURE__ */ React.createElement("span", null, defaultText);
const CacheConfigFormFields = React.forwardRef(({ validationErrors }, configRef) => {
  const {
    values: { config }
  } = useFormikContext();
  const cachePlugins = usePluginEntities("lookupTableCaches");
  const plugin = cachePlugins.find((p) => p.type === (config == null ? void 0 : config.type));
  const ConfigForm = useMemo(() => plugin == null ? void 0 : plugin.formComponent, [plugin]);
  if (!plugin) return null;
  return /* @__PURE__ */ React.createElement(ConfigForm, { config, ref: configRef, validationMessage: validationMessageRenderer(validationErrors) });
});
export default CacheConfigFormFields;
